export default __webpack_public_path__ + "static/media/num-two.8d623fbf.svg";